import React, { useState, useRef, useEffect } from "react";
import LoadingBar from "react-top-loading-bar";
import TopBar from "../../sections/TopBar";
import Sidebar from "../../sections/Sidebar";

const Tools = () => {
  const ref = useRef();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  useEffect(() => {
    document.title = "Tools Purchased || Admin Panel";
    window.scrollTo(0, 0);

    const handleResize = () => {
      if (window.innerWidth < 768) setIsSidebarOpen(false);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  return (
    <>
      <LoadingBar color="#084e8a" ref={ref} height={5} />
      <div className={`main_layout ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
        <Sidebar isSidebarOpen={isSidebarOpen} />
        <div className="innerRight">
          <TopBar title="Tools Purchased" menu="" toggleSidebar={toggleSidebar} />
          <div className="officersSec">
            <h3 className="colorHeadThree">Tools Purchased</h3>
            <p className="mt-4">Tools content coming soon...</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tools;